import PropTypes from "prop-types";
import {
  Typography,
  Box,
  Button,
  Stack,

} from "@mui/material";

import DataTable from "src/components/DataTable";
import React from "react";
import dayjs from "dayjs";
const columns = [
    { field: "plan_mid", headerName: "ID", width: 90 },
    {
      field: "plan_name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "date",
      headerName: "Expire date",
      renderCell:(params)=><Stack direction="row" gap={2}>{dayjs(params?.Exp_date).format("DD-MM-YYYY")}</Stack>,
      flex: 1,
      minWidth: 150,
    },
    {
      field: "start_date",
      renderCell:(params)=><Stack direction="row" gap={2}>{dayjs(params?.start_date).format("DD-MM-YYYY")}</Stack>,
      headerName: "Start Date",
      flex: 1,
      minWidth: 150,
    },
    {
        field: "actions",
        headerName: "Status",
        renderCell:(params)=><Stack direction="row" color={dayjs(params?.Exp_date).format("DD-MM-YYYY")>=dayjs().format("DD-MM-YYYY")?"green":"red"} gap={2}>{dayjs(params?.Exp_date).format("DD-MM-YYYY")>=dayjs().format("DD-MM-YYYY")?"Active":"Expired"}</Stack>,
        sortable: false,
        filterable: false,
        flex: 1,
        minWidth: 150,
      },
    // {
    //   field: "ItemName",
    //   headerName: "Active Plan",
    //   flex: 1,
    //   minWidth: 150,
    // },
  //   {
  //     field: "hostel",
  //     headerName: "Hostel",
  //     flex: 1,
  //     minWidth: 150,
  //   },
  ];
function PlanHistory({ plans,onClose,data }) {

const plan=plans.filter((item)=>item.user_id===data.uid)
 
  return (
    <Box sx={{ p: 1 }} >

      <Typography variant="h6">
        Plans history
      </Typography>
      <DataTable columns={columns} rows={plan}/>

    <Button onClick={onClose}>Close</Button>
    </Box>
  );
}

PlanHistory.propTypes = {
  plans:PropTypes.any,
  onClose:PropTypes.any,
  data:PropTypes.any

};

export default PlanHistory;
